<template>
  <div class="question" :class="questionIndex === $store.state.step ? 'active' : ''">
    <div class="previous" @click="getPreviousQuestion" v-if="questionIndex > 0">
      前の質問に戻る
    </div>
    <div class="question__label">
      {{question.label}}
    </div>
    <div class="question__answers">
      <Answer v-for="(answer, index) in question.answers" :question="question" :answer="answer" :key="index" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Answer from '@/components/vertical-cards/Answer.vue'

export default {
  props: {
    question: {
      type: Object
    }
  },
  components: {
    Answer
  },
  computed: {
    questionIndex () {
      return this.$vnode.key
    }
  },
  methods: {
    ...mapActions(['getPreviousQuestion'])
  }
}
</script>

<style lang="scss" scoped>
.question {
  visibility: hidden;
  height: 0;
  opacity: 0;
  transform: scale(0.9);

  &.active {
    visibility: visible;
    opacity: 1;
    height: auto;
    display: block;
    transform: scale(1);
    transition: .3s;
  }

  .previous {
    font-size: 12px;
    color: #9b59b6;
    margin-bottom: 12px;
    cursor: pointer;
  }

  .question__label {
    font-size: 22px;
    font-weight: 800;
    margin-bottom: 28px;
  }
}
</style>
